export const vesselNames = [
  "Gallipoli Seaways",
  "Olympos Seaways",
  "Cappadocia Seaways",
  "Aspendos Seaways",
  "Dardanelles Seaways",
  "Assos Seaways",
  "Artemis Seaways",
  "Zeugma Seaways",
  "Sumela Seaways",
  "Myra Seaways",
  "Galata Seaways",
  "Pergamon Seaways",
  "Ephesus Seaways",
  "Troy Seaways",
  "Fadiq",
  "Paqize",
  "Pol Stella",
  "Francesco Nullo",
  "Lismore",
  "Patria Seaways",
];

// Define your array of strings
export const logisticsCompanies = [
  "HNR LOJISTIK A.S",
  "EKOL LOJISTIK LTD STI",
  "MARS LOJISTIK A.S",
  "LKW Walter AG",
  "SCHENKER ARKAS",
];
export const podTypes = ["RAIL", "ROAD"];

export const customerNotes = [
  "Duisburg",
  "Bet",
  "Bett",
  "Koln",
  "Bettembourg",
  "Cologne",
  "Wels",
  "Wels",
  "No Note",
];

export const customerMappings: { [customerNo: number]: string } = {
  87448: "MARS LOJISTIK A.S",
  82630: "EKOL LOJISTIK LTD STI",
  88608: "MIRAN ULUSLARARASI NAKLIYE VE DIS TICARET LIMITED SIRKETI",
  88604: "SARP INTERMODAL HIZ. IC VE DIS TIC. A.S.",
};

export const unitToVesselMappings: { [unitNumber: string]: string } = {
  "34CEL508": "TROY",
  "34GBT240": "TROY",
  "34EB3663": "TROY",
  EKOE4585265: "TROY",
  "33L5895": "MYRA",
  MXMU1453591: "MYRA",
  AMXU6301902: "GALATA",
  SARBB2000266: "GALATA",
  SRPU2007685: "GALATA",

  "33ALS895": "MYRA",
  SARB2000266: "GALATA",
};

// Function to generate a random string of specified length
export const randomString = (length: number) =>
  Math.random().toString(36).substr(2, length).toUpperCase();

// Function to generate a random integer within a specified range
export const randomInt = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

// Function to generate a random date in ISO format
export const randomDate = () =>
  new Date(+new Date() - Math.floor(Math.random() * 500000000)).toUTCString();

// Function to generate a random ILU code (4 letters followed by 7 numbers)
export const randomIluCode = () =>
  `${randomString(4)}${randomInt(1000000, 9999999)}`;

export function getRandomStatus() {
  const strings = ["New"];
  const randomIndex = Math.floor(Math.random() * strings.length);
  return strings[randomIndex];
}

export function getRandomVessel() {
  const randomIndex = Math.floor(Math.random() * vesselNames.length);
  return vesselNames[randomIndex];
}

export function overwriteDate(dateString: string | number | Date) {
  if (dateString === undefined) return "";
  const date = new Date(dateString);

  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  return formattedDate;
}

export const getTomorrowDate = () => {
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  return tomorrow.toISOString().split("T")[0];
};

export function getRandomElement(arr: string[]) {
  // Generate a random index based on the length of the array
  const randomIndex = Math.floor(Math.random() * arr.length);

  // Return the element at the random index
  return arr[randomIndex];
}
